import { Box } from '@mui/material';
import { FC } from 'react';
import { baseCardButtonStyling, baseCardStyling } from './styles';

type NumberBoxProps = {
  number: number;
  onClick: (number: number) => void;
};

export const NumberBox: FC<NumberBoxProps> = ({ number, onClick }) => {
  return (
    <Box
      sx={{
        ...baseCardStyling,
        ...baseCardButtonStyling,
      }}
      onClick={() => onClick(number)}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          onClick(number);
        }
      }}
    >
      {number}
    </Box>
  );
};
